export const SET_MESSAGE = 'SET_MESSAGE';